export default __webpack_public_path__ + "static/media/distance.bd9dd88d.png";